import * as Lens from "..";
import * as Getter from "../../getter";
import * as Setter from "../../setter";
export const prop = (k) => Lens.lens(Getter.getter((x) => x[k]), Setter.setter((g) => (x) => (Object.assign(Object.assign({}, x), { [k]: g(x[k]) })), (x) => (s) => (Object.assign(Object.assign({}, s), { [k]: x }))));
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const kv = (k) => prop(k);
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export function path(k1, ...ks) {
    return ks.reduce((l, k) => Lens.compose(l, prop(k)), 
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    prop(k1));
}

